<template>
   <div class="page-wrapper">
    <div class="container-fluid">
        <!-- sign up page start-->
        <div class="authentication-main">
            <div class="row">
                <div class="col-md-12 p-0">
                    <div class="auth-innerright">
                        <div class="authentication-box">
                            <div class="card p-3">
                                <div class=" d-flex flex-row justify-content-between ">
                                    <div >
                                        <a  v-on:click="toggle_fullscreen()">
                                            <feather class="text-back mt-4 ml-2"  type="maximize" size="25"></feather>
                                        </a>                                            
                                    </div>
                                    <div>
                                        <div class="text-center">
                                            <img alt="" src="../assets/images/hor-th_100.png">
                                        </div>  
                                        <span class="mb-3 text-center text-danger f-w-900" style="font-size: 16px;">{{ $t('loginPage.hor-th') }} </span>                                         
                                    </div>
                                    <div class="mt-4"  style="text-align: end"><LocaleSwitcher/></div>       
                                </div>         
                                <div class="text-center">
                                    <h5>{{ $t('loginPage.login') }}</h5>
                                    <h6 class="text-center text-info ">{{ $t('loginPage.enterEmailPwd') }} </h6>
                                </div>
                                <div id="recaptcha-container"></div>
                                <form class="theme-form">
                                <div class="form-group">
                                    <label class="col-form-label text-primary f-w-600 pt-0">{{ $t('loginPage.yourEmailMb')}}</label>
                                    <input v-model="emailMb" @input="isMbNo" class="form-control ml-2" type="text" :placeholder="$t('loginPage.enterEmailPhonePh')">
                                    <span v-show="errorNotMbNo != ''" class=" ml-2 f-w-600 text-danger" > {{ $t('loginPage.notMbNo') }}</span>
                                </div>
                                <div v-show="showPwdInput" >
                                    <label class="col-form-label text-primary f-w-600">{{ $t('loginPage.pwd') }}</label>
                                    <div class="d-flex flex-row justify-content-start">
                                        <div class="col-sm-6"> 
                                            <input v-model="password" :type="type" class="form-control" name="loginpassword" :placeholder="$t('loginPage.enterPwdPh')">
                                        </div>
                                        <div class="col-sm-2"> 
                                            <feather @click="showPassword" class="text-dark mt-2" :type="iconType"  size="20"></feather>   
                                        </div>
                                    </div>
                                </div>
                                <b-modal ref="verifyMb-modal"  :title="$t('loginPage.verifyMbTitle')" hide-footer>
                                    <div class="d-block">
                                        <span class="f-w-600 text-primary" style="font-size:16px">{{ $t('loginPage.verifyMbMsg') }}<span class="text-success">{{ emailMb}} </span></span>
                                    </div>
                                    <div class="col-sm-12">                                   
                                        <form @submit.stop.prevent="verifyMbModal">
                                            <div class="row ml-2">                                                   
                                                <label class="f-w-600 text-dark mt-1 mr-2" style="font-size:16px;">{{ $t("loginPage.verificationCode")}}:</label>
                                                <input type="text" class=" f-w-600 text-primary" style="font-size:16px" v-model="verificationCode">   
                                                <span v-show="showWrongCode" class=" f-w-600 text-danger" > {{ $t('loginPage.wrongCode') }}</span>
                                            </div>
                                        </form>  
                                        <b-button-group>
                                            <b-button  class="mt-1" size="md" variant="warning"  @click="resendModal">
                                                <span style="font-size: 14px;">
                                                    {{ $t("loginPage.resend") }}
                                                </span>                                                                             
                                            </b-button>
                                            <b-button  class="mt-1" size="md" variant="danger"  @click="cancelModal">
                                                <span style="font-size: 14px;">
                                                    {{ $t("refill.cancel") }}
                                                </span>                                                                             
                                            </b-button>                       
                                            <b-button class="mt-1 ml-4" size="lg" variant="primary"  @click="verifyMbModal">
                                                <span style="font-size: 16px;">
                                                    {{ $t("loginPage.continue") }}
                                                </span>                                                                             
                                            </b-button>     
                                        </b-button-group>                                   
                                    </div>   
                                </b-modal>
                                <div v-if="showPwdInput" class="mt-0 mb-5" style="text-align: right" > 
                                    <span class="text-info text-underline mt-3"  @click="goForgotPassword"> {{ $t('loginPage.forgotPassword') }}</span>
                                </div>
                                <div v-else class="mt-0 mb-5" style="text-align: right" > 
                                    <span class="text-info text-underline mt-3"  @click="showPwdInput = true"> {{ $t('loginPage.signInEmail') }}</span>
                                </div>
                                <!-- <div class="checkbox p-0">
                                    <input id="checkbox1" type="checkbox">
                                    <label for="checkbox1">Remember me</label>
                                </div> -->
                                <div class="form-group form-row mt-3 mb-0">
                                    <button class="btn btn-primary btn-block" style="font-size: 18px;" type="button" @click="doLogin">{{  showPwdInput? $t('loginPage.signIn') : $t('loginPage.signInMb') }}</button>
                                </div>
                                <div class="form-group form-row mt-3 mb-0">
                                    <!-- <button class="btn btn-secondary btn-block" type="button" @click="">Login With
                                        Auth0
                                    </button> -->
                                    <button v-show="showPwdInput" class="btn btn-secondary btn-block" style="font-size: 18px;" type="button"  @click="goRegister">{{ $t('loginPage.register') }}</button>
                                    <!-- <button class="btn btn-secondary btn-block" style="font-size: 18px;" type="button"  v-show="registerBTN" @click="goRegister">{{ $t('loginPage.register') }}</button> -->
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 </div>
</template>
  
<script>
//   import firebase from './firebase';
import { onAuthStateChanged, signInWithEmailAndPassword , signInWithPhoneNumber,signOut, RecaptchaVerifier} from "firebase/auth";
import {authUser, saveWithId, createNewUserWallet, getDocById} from "../firebase"
import {getRandomInt} from "../utilities/util"
import LocaleSwitcher from "../components/localSwitcher.vue"
authUser.languageCode = 'th'
export default {
    components: { LocaleSwitcher },
    data() {
        return {
        user: null, // This will hold the authenticated user object or null
        loadingAuth: true,// To indicate if we're still checking the auth state on load

        emailPattern : /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g,
        mobilePattern : /^\d{10}$/,
        showPwdInput : false,
        type: 'password',
        iconType: 'eye-off',
        emailMb: '',
        password: '',
        showWrongCode: false,
        errorNotMbNo : '',
        recaptchaVerifier: null,
        confirmationResult : '',
        verificationCode: ''
        };
    },
    mounted() {

        const unsubscribe = onAuthStateChanged(authUser, (user) => {
            //console.log("Auth state changed. User:", user ? user.uid : "null");
            this.user = user; // Update the user data property
            this.loadingAuth = false; // Authentication state check is complete

            if (user) {
                // User is signed in (either just logged in, or found via persistent session)
                // console.log(`User is signed in with UID: ${user.uid}`);
                // Redirect or show content for logged-in users
                // Example: this.$router.push('/dashboard');
               // this.$toasted.show(this.$t('loginPage.signedIn') + `${ user.email || user.phoneNumber}`, {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 20000});
                let userCat = localStorage.getItem('userCat')
                // console.log(`user was signed in , userCat : ${userCat}`);
                switch (userCat) {
                    case 'member':
                        setTimeout(function () {
                            window.location.href='/process/lucking'  
                        },500)                                         
                        break;
                    case 'admin':
                        setTimeout(function () {
                            window.location.href='/process/refillCC' 
                        },500)                                         
                        break;
                    case 'host':
                        setTimeout(function () {
                            window.location.href='/process/importCSV'  
                        },500)                                         
                        break;  
                    default:
                        break;
                }      
            } else {
                // User is signed out (either explicitly, or no persistent session found)
                console.log("No user is signed in.");
                // Redirect or show content for logged-out users (e.g., login page)
                // Example: this.$router.push('/login');
            }
        });

        // Important for SPAs: Clean up the listener when the component is destroyed
        this.$once('hook:beforeDestroy', () => {
            console.log("Detaching onAuthStateChanged listener.");
            unsubscribe();
        });

        this.recaptchaVerifier = new RecaptchaVerifier(authUser,'recaptcha-container', {
            size: 'invisible',
            callback: (response) => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
                // this.signInWithMb();
                console.log(`signInPhoneNumber : ${JSON.stringify(response)}`)
            },
        });
        // console.log(`this.recaptchaVerifier => ${JSON.stringify( this.recaptchaVerifier , null , 2)}`)
    },
    methods: {
        showPassword() {
            if (this.type === 'password') {
            this.type = 'text'
            this.iconType = 'eye'
            } else {
            this.type = 'password'
            this.iconType = 'eye-off'
            }
        },
        doLogin(){
            const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
            const mobilePattern = /^\d{10}$/
            let emailTest = emailPattern.test(this.emailMb)
            let mobileTest = mobilePattern.test(this.emailMb)
            let msg = 'completed'
            if (this.emailMb ===''){
                msg = this.$t('loginPage.enterEmailMbMsg')
            } else { 
                if (emailTest || mobileTest){
                    msg = 'completed'
                } else {
                    msg = this.$t('loginPage.emailMbPatternMsg')
                }
            }
            if (msg === 'completed'){
                if (emailTest) {
                    console.log(`email=> ${this.emailMb}`)
                    this.signInWithEmail(this.emailMb )
                } else if( mobileTest){
                    console.log(`mobile=> ${this.emailMb}`)
                    this.signInWithMb()
                }
            } else {
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 8000});     
            }
        },
        async signInWithEmail(email) {
            let msg = 'completed'
            if (this.password ===''){
                msg = this.$t('loginPage.enterPwdMsg')
            } else if (this.password.length < 8){
                msg = this.$t('loginPage.pwd8UpMsg')
            }  
            if (msg === 'completed'){
                signInWithEmailAndPassword(authUser, email, this.password)
                .then(async(userCredential) => {
                    if (userCredential.user) {
                        await getDocById("Users", "uid", userCredential.user.uid, async(res)=>{
                        // userInfoByUid(userCredential.user.uid, (res)=>{
                            console.log(`signInWithEmail, User info=> ${JSON.stringify(res , null ,2)}`)
                            this.$toasted.show(this.$t('loginPage.successLogin') + res[0].email, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});
                            localStorage.setItem('user', res[0].email)
                            localStorage.setItem('phone', res[0].phone)
                            localStorage.setItem('userId', res[0].userId)
                            localStorage.setItem('userCat', res[0].userCat)
                            localStorage.setItem('name', res[0].name)
                            switch (res[0].userCat) {
                                case 'member':
                                    setTimeout(function () {
                                        window.location.href='/process/lucking'  
                                        // window.location.href='/auth/clickLucking'  
                                    },500)                                         
                                    break;
                                case 'admin':
                                    setTimeout(function () {
                                        // window.location.href='/'  
                                        window.location.href='/process/refillCC' 
                                    },500)                                         
                                    break;
                                case 'host':
                                    setTimeout(function () {
                                        // window.location.href='/'
                                        window.location.href='/process/importCSV'  
                                    },500)                                         
                                    break;  
                                default:
                                    break;
                            }                                    
                        })                               
                    } else {
                        this.$toasted.show(this.$t('loginPage.failLoginEamil') , {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 10000});
                    }
                })
                .catch((error) => {
                    this.$toasted.show(`${this.$t('loginPage.failLoginEmail')} : ${error.message}`, {theme: 'bubble',   position: 'bottom-center',   type: 'error', duration: 10000});
                });                                                 
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async signInWithMb() {
            let msg = 'completed'
            let p = `${this.emailMb}`
            // console.log(`signInWithPhoneNumber, p => ${p}`)
            let mb1stDigit = p.substring(0,1)
            if (mb1stDigit !=='0'){
                msg = this.$t('loginPage.notMobileNumberMsg')
            } else if (this.emailMb.length !== 10){
                msg = this.$t('loginPage.mobileNumber10DigitsMsg')
            }  

            // console.log(`Thai mobile : +66${p.substring(1,10)}`)
            // let phoneNumber = '+16505552222' // test phone number authentication (Firebase) 
            // let phoneNumber = '+66892570156' 
            let phoneNumber = `+66${p.substring(1,10)}`       
            //let phoneNumber = `+16${p.substring(1,10)}`            
            // console.log(` mobile No : ${phoneNumber}`)
            if (msg === 'completed'){
                try { 
                    // const appVerifier = this.recaptchaVerifier;
                    await signInWithPhoneNumber(authUser, phoneNumber,  this.recaptchaVerifier).then((result)=>{
                        if (result) {
                            this.confirmationResult = result
                            this.openModalVerifyMb()
                            this.errorNotMbNo = ''
                        } 
                        else {
                            this.errorNotMbNo = this.$t('loginPage.failMbNo')
                            // this.$toasted.show(this.$t('loginPage.plsCheckMbNo'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000}); 
                        }
                    });
                    // console.log(`signInWithPhoneNumver, confirmationResult:=>${JSON.stringify( this.confirmationResult, null , 2)}`);
                } catch (error) {
                    this.confirmationResult = ''
                    this.errorNotMbNo = this.$t('loginPage.notMbNo') 
                    this.$toasted.show(this.$t('loginPage.plsCheckMbNo') + " Error: " +`${ error.message}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000}); 
                    // console.error('Error signing in with phoneNumber:', error.message);
                }
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        async confirmCode(){
            console.log(`confirmCode, confirmationResult:=>${JSON.stringify( this.confirmationResult, null , 2)}`);
            try {
                // const code = window.prompt('Enter the verification code you received:');
                await this.confirmationResult.confirm(this.verificationCode).then(async(userCredential)=>{
                    await getDocById("Users", "uid", userCredential.user.uid, async(res)=>{
                        // console.log(`confirmCode, User info=> ${JSON.stringify(res , null ,2)}`)
                        if (res.length === 0) { // register new member
                            let userId = `${getRandomInt(1000000 , 9000000)}`
                            let payload = {
                                uid: userCredential.user.uid,
                                userId : userId,
                                name: this.emailMb,
                                phone: this.emailMb,
                                userCat: 'member',  
                                email: '',                                                      
                                ftName: this.emailMb, 
                                dayBD: '',
                                monthBD: '',
                                yearBD: '',
                                timeBD: '',
                                estTime: '',
                                placeBD: '',                            
                                lrs: '',
                            }
                            await saveWithId('Users', userId, payload).then(()=>{
                                this.$toasted.show(this.$t("loginPage.successRegisterMb") + this.emailMb, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});    
                                localStorage.setItem('user', '')
                                localStorage.setItem('phone', this.emailMb)
                                localStorage.setItem('userId', userId)
                                localStorage.setItem('userCat', 'member')
                                localStorage.setItem('name', this.emailMb )
                                setTimeout(function () { 
                                    window.location.href='/process/lucking'  
                                },500)                                       
                            })
                            await createNewUserWallet( 1 , userId)
                        } else { // exiting member
                            this.$toasted.show(this.$t('loginPage.successLogin') + res[0].email, {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});
                            localStorage.setItem('user', res[0].email)
                            localStorage.setItem('phone', res[0].phone)
                            localStorage.setItem('userId', res[0].userId)
                            localStorage.setItem('userCat', res[0].userCat)
                            localStorage.setItem('name', res[0].name)
                            switch (res[0].userCat) {
                                case 'member':
                                    setTimeout(function () {
                                        window.location.href='/process/lucking'  
                                    },500)                                         
                                    break;
                                case 'admin':
                                    setTimeout(function () {
                                        window.location.href='/process/refillCC' 
                                    },500)                                         
                                    break;
                                case 'host':
                                    setTimeout(function () {
                                        window.location.href='/process/importCSV'  
                                    },500)                                         
                                    break;  
                                default:
                                    break;
                            }                                   
                        }
                        this.$refs['verifyMb-modal'].hide()  
                    })
                });
            } catch (error) {
                this.showWrongCode = true
                this.$toasted.show(this.$t('loginPage.plsCheckVerificationCode') + " Error: " +`${ error.message}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000}); 
            }
        },
        goRegister() {
            this.$router.push('/auth/register');
        },
        goForgotPassword(){
            this.$router.push('/auth/forgotPassword');
        },
        isMbNo(){
            const mobilePattern = /^\d{10}$/
            let mobileTest = mobilePattern.test(this.emailMb)
            if (mobileTest) {
                this.showPwdInput = false
            } else{
                this.showPwdInput = true
            }
        },

        openModalVerifyMb() {
            this.verificationCode = ''
            this.$refs['verifyMb-modal'].show()
            this.$root.$emit('bv::show::modal', "verifyMbModal" )
        },
        resendModal() {
            this.$refs['verifyMb-modal'].hide()
            this.verificationCode = ''
        },
        cancelModal() {
            this.$refs['verifyMb-modal'].hide()
            this.verificationCode = ''
            this.emailMb = ''
            this.showPwdInput = true   // back to email/mb
        },
        async verifyMbModal() {
            if (this.verificationCode == '') {
                this.$toasted.show( this.$t("loginPage.addVerificationCodeMsg") + " Error: " +`${ error.message}`, {theme: 'bubble', type: 'danger' , position: 'bottom-center', duration: 5000}); 
            } else {
                this.showWrongCode = false
                this.confirmCode()
            }
        },
        toggle_fullscreen() {
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
                }
            }
        }
    }
};
</script>
  